import React from 'react';
import { Trans } from 'react-i18next';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import { RECEIPT_API } from '../../api/receipt.js';
import { IMAGES, INTERNAL_LINKS } from '../../enum/index.jsx';
import { getMinutesAsMilliseconds } from '../../utils/numbers.js';
import LinkText from '../Text/LinkText.js';
import Alert from './index.js';

const OverdueReceiptAlert = props => {
  const { t, userId, groupId, companyId, onClick } = props;

  const overdueCountQuery = useQuery({
    staleTime: getMinutesAsMilliseconds(5),
    queryKey: ['overdueCount', userId, groupId, companyId],
    queryFn: () => RECEIPT_API.fetchOverdueCount({ userId, groupId, companyId }),
  });

  if (typeof overdueCountQuery.data?.overdueCount !== 'number') return null;

  if (overdueCountQuery.data.overdueCount === 0) {
    return (
      <Alert
        closable={false}
        icon={<img width="24px" src={IMAGES.CALENDAR_CHECK_ICON} alt="calendar check" />}
        message={
          <Trans
            t={t}
            i18nKey="noOverdueReceipt"
            components={[
              <Link to={INTERNAL_LINKS.DASHBOARD}>
                <LinkText variant="strong">DummyText</LinkText>
              </Link>,
            ]}
          />
        }
      />
    );
  }

  return (
    <Alert
      closable={false}
      icon={<img width="24px" src={IMAGES.CALENDAR_WARNING_ICON} alt="calendar warning" />}
      message={
        <Trans
          t={t}
          i18nKey="overdueReceipt"
          count={overdueCountQuery.data.overdueCount}
          values={{ count: overdueCountQuery.data.overdueCount }}
          components={[
            <LinkText variant="strong" onClick={onClick}>
              DummyText
            </LinkText>,
          ]}
        />
      }
    />
  );
};

export default OverdueReceiptAlert;
